import config from '../config';

const GUEST_ID_KEY = 'outr_guest_id';

const generateUUID = () => {
    // Basic UUID generator for guest tracking
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

export const getGuestId = () => {
    try {
        let guestId = localStorage.getItem(GUEST_ID_KEY);
        if (!guestId) {
            guestId = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : generateUUID();
            localStorage.setItem(GUEST_ID_KEY, guestId);
        }
        return guestId;
    } catch (e) {
        console.warn('LocalStorage is not available, using temporary guestId');
        return typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : generateUUID();
    }
};

export const trackEvent = async ({ eventId, hostId, actionType, metadata = {} }) => {
    if (!eventId || !hostId || !actionType) {
        console.warn('trackEvent: Missing required parameters (eventId, hostId, actionType)');
        return;
    }

    try {
        const payload = {
            eventId,
            hostId,
            actionType,
            guestId: getGuestId(),
            metadata: {
                ...metadata,
                timestamp: new Date().toISOString()
            }
        };

        const response = await fetch(`${config.API_BASE_URL}/api/v1/user/track-event`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "ngrok-skip-browser-warning": "any-value"
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            // Silently handle tracking failures
            console.warn(`Tracking failed: ${response.status}`);
        }
    } catch (error) {
        // Silently handle network errors
        console.warn('Tracking error:', error);
    }
};
